<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-form :form="form" @submit="handleSubmit">
        <a-row>
          <a-col :span="22">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="负责人"
              hasFeedback
            >
              <a-select
                :allowClear="true"
                class="itemWidth"
                placeholder="请选择负责人"
                :disabled="!isEdit"
                v-decorator="['leaderId', { rules: [{ required: true, message: '请选择负责人！' }] }]"
              >
                <a-select-option v-for="(item,index) in userList" :value="item.id" :key="index">
                  {{ item.userName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" style="margin-top: 10px; text-align: right">
            <a-button type="primary" html-type="submit" style="margin-right:10px;">
              提交
            </a-button>
            <a-button style="margin-right:10px;" @click="cancel">
              取消
            </a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'
import { changeLeader } from '@/api/markets'
import { addressOptions } from '@/utils/proviceData.js'
export default {
  name: 'EditMarkets',
  mounted () {

  },
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    userList () {
      return this.$store.state.market.userList
    }
  },
  components: {
    baseModal
  },
  data () {
    return {
      title: '操作',
      width: 600,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'markets' }),
      visible: false,
      defaultModel: {},
      model: {},
      headers: {
        authorization: 'authorization-text'
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      options: addressOptions,
      proprietorContactsList: [], // 业主联系人列表
      designContactsList: [], // 设计代表联系人列表
      provinceId: 1,
      cityId: 2,
      districtId: 3
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      console.log(JSON.stringify(model))
      this.model = Object.assign({}, model)
      this.form.setFieldsValue({
        id: this.model.id,
        leaderId: this.model.leaderId
      })
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = {
            id: this.model.id,
            leaderId: value.leaderId
          }
          changeLeader(params).then(res => {
            if (res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.error(res.info.message)
            }
          })
        }
      })
    },
    // 清空表单
    formClear () {
      this.form.setFieldsValue({
        leaderId: null,
        id: null
      })
    },
    cancel () {
      this.formClear()
      this.open(false)
    }
    // 获取select列表

  }
}
</script>

<style scoped>

</style>
